import { render, staticRenderFns } from "./DrivingLessonTaskGroupCard.vue?vue&type=template&id=0b9dfedd&scoped=true"
import script from "./DrivingLessonTaskGroupCard.vue?vue&type=script&lang=ts"
export * from "./DrivingLessonTaskGroupCard.vue?vue&type=script&lang=ts"
import style0 from "./DrivingLessonTaskGroupCard.vue?vue&type=style&index=0&id=0b9dfedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dfedd",
  null
  
)

export default component.exports